import React,{useState,useEffect }  from 'react';

import Layout from './layout/DefaultLayout';

const Home = () =>{
    const [userData, setUserData] = useState({});
 //const isAdmin = userData.userRole === 1; // replace with your admin user ID
 //console.log(isAdmin);
 //const isAgencyUser = userData.userRole === 2; 
 //console.log(data.userName);

useEffect(() => {
    const data = JSON.parse(localStorage.getItem('token'));
    setUserData(data);
  }, []);
return(

    <>
    <Layout/>
    
    </>
    
);
}

export default Home;